import recommendationProduct from './recommendation-product';

/**
 * @param {Array<Object>} products - product data to print
 * @param {boolean} showFlags - show flags
 * @returns {string} recommendations HTML
 */
export default (products, showFlags = false) => {
    if (!products) {
        return '';
    }
    return products.map((product, index) => recommendationProduct(product, index, showFlags)).join('');
};
